import { withProps } from 'recompose';

import { Homepage } from './pages/Homepage';
import { EventsGrid, eventsPath } from '@modules/events/EventsGrid';
import { DelictsGrid, delictsPath } from '@modules/delicts/DelictsGrid';
import { DogsGrid, dogsPath } from '@modules/dogs/DogsGrid';
import { BicyclesGrid, bicyclesPath } from '@modules/bicycles/BicyclesGrid';
import { MyOverview } from '@modules/hr-overview/MyOverview';
import { AllOverviews } from '@modules/hr-overview/AllOverviews';
import { MyPlans } from '@modules/hr-plans/MyPlans';
import { PeriodsGrid, periodsPath } from '@modules/hr-templates/periods/PeriodsGrid';
import { DaysGrid, daysPath } from '@modules/hr-templates/days/DaysGrid';
import { WeeksGrid, weeksPath } from '@modules/hr-templates/weeks/WeeksGrid';
import { DayplansGridSingle, dayplansPath } from '@modules/hr-dayplans/DayplansGridSingle';
import { ShiftsGrid, shiftsPath } from '@modules/hr-shifts/ShiftsGrid';
import { ShiftCyclesGrid, shiftsCyclesPath } from '@modules/hr-shift-cycles/ShiftCyclesGrid';
import { ShiftCycleDetail } from '@modules/hr-shift-cycles/ShiftCycleDetail';
import { EmployeeDetail } from '@modules/hr-employee-detail/EmployeeDetail';
import { CalendarsGrid, calendarsPath } from '@modules/hr-templates/calendars/CalendarsGrid';
import { TasksGrid, tasksPath } from '@modules/tasks/TasksGrid';
import { MyTasksGrid, myTasksPath } from '@modules/tasks/MyTasksGrid';
import { InventoryCardsGrid, inventoryCardsPath } from '@modules/inventoryCards/InventoryCardsGrid';
import { EmployeesGrid, employeesPath } from '@modules/employees/EmployeesGrid';
import { TicketsGrid, ticketsPath } from '@modules/tickets/TicketsGrid';
import { Dictionary } from '@modules/dictionary/Dictionary';
import { WantedPersonsGrid, wantedPersonPath } from '@modules/wantedPersons/WantedPersonsGrid';
import { WantedVehiclesGrid, wantedVehiclesPath } from '@modules/wantedVehicles/WantedVehiclesGrid';
import { ProtocolsGrid, protocolsPath } from '@modules/protocols/ProtocolsGrid';
import { ProtocolsForm } from '@modules/protocols/ProtocolsForm';
import {
  OperationalWarehouseGrid,
  operationalWarehousePath
} from '@modules/operationalWarehouse/operationalWarehouseGrid';
import { MyItemsGrid, myItemsPath } from '@modules/myItems/myItemsGrid';
import { MyRequestsGrid, myRequestsPath } from '@modules/requests/my-requests/myRequestsGrid';
import { protocolCreateFormEnum } from '@modules/protocols/_protocolsEnums';
import { RepairsGrid, repairsPath } from '@modules/repairs/RepairsGrid';
import { ReportsGrid, reportsPath } from '@modules/reports/ReportsGrid';
import { ErrorsGrid, errorsPath } from '@modules/errors/ErrorsGrid';
import { TripsGrid, tripsPath } from '@modules/trips/TripsGrid';
import { RepairsCreateForm } from '@modules/repairs/RepairsCreateForm';
import { RepairType } from '@modules/repairs/_repairsEnums';
import { GeneralSettingsForm } from '@modules/generalSettings/GeneralSettingsForm';
import { TicketsGenerateForm } from '@modules/tickets/TicketsGenerateForm';
import { DayplansForm } from '@modules/hr-dayplans/DayplansForm';
import { RolesCreateGrid, rolesCreatePath } from '@modules/roles-create/RolesCreateGrid';
import { RolesAssignGrid, rolesAssignPath } from '@modules/roles-assing/RolesAssignGrid';
import { RequestsPayGrid, requestsPayPath } from '@modules/hr-requests/pays/RequestsPayGrid';
import { WorkPositionsGrid, workPositionsPath } from '@modules/hr-workPositions/WorkPositionsGrid';
import { RequestsHolidayGrid, requestsHolidayPath } from '@modules/hr-requests/holidays/RequestsHolidayGrid';
import { ClaimsGrid, claimsPath } from '@modules/hr-workTimes/claim/ClaimsGrid';
import { SummaryForm } from '@modules/hr-workTimes/summary/SummaryForm';
import { JobsGrid, jobsPath } from '@modules/jobs/JobsGrid';
import { mapPath, Map as MetropolisMap } from '@modules/maps/Map';
import { HistoryGrid, historyPath } from '@modules/history/HistoryGrid';
import { workDayTypesPath, WorkDayTypesGrid } from '@modules/hr-workDayTypes/WorkDayTypesGrid';
import './styles/style.css';
import 'leaflet/dist/leaflet.css';
import {
  tasksCode,
  dogsCode,
  bicyclesCode,
  mapCode,
  hrCode,
  warehousesCode,
  tripsCode,
  wantedPersonCode,
  wantedVehiclesCode,
  operationalWarehousesCode
} from './moduleCodes';
import {
  eventsPermission,
  delictsPermission,
  tasksPermission,
  employeesPermission,
  ticketsPermission,
  dogsPermission,
  bicyclesPermission,
  mapPermission,
  hrMyPermission,
  hrMyPlansPermission,
  hrRequestsPermission,
  hrWorkTimesPermission,
  hrTemplatesPermission,
  hrDayplansPermission,
  hrShiftsPermission,
  hrWorkPositionsPermission,
  warehouseInventoryCardsPermission,
  warehouseProtocolsPermission,
  tripsPermission,
  wantedPermission,
  repairsPermission,
  reportsPermission,
  dictionariesPermission,
  historyPermission,
  administrationPermission,
  workDayTypesPermission,
  operationalWarehouseOwnListPermission,
  operationalWarehouseRequestListPermission,
  operationalWarehousePermission
} from './permissions';
import { RequestsGrid, requestsPath } from '@modules/requests/requestsGrid';

export const routes: any = [
  {
    path: '/',
    component: Homepage
  },
  { path: eventsPath, component: EventsGrid, permissions: [eventsPermission] },
  { path: delictsPath, component: DelictsGrid, permissions: [delictsPermission] },
  { path: tasksPath, component: TasksGrid, moduleCodes: [tasksCode], permissions: [tasksPermission] },
  { path: myTasksPath, component: MyTasksGrid, moduleCodes: [tasksCode], permissions: [tasksPermission] },
  { path: employeesPath, component: EmployeesGrid, permissions: [employeesPermission] },
  { path: ticketsPath, component: TicketsGrid, permissions: [ticketsPermission] },
  { path: '/tickets/generate', component: TicketsGenerateForm, permissions: [ticketsPermission] },
  { path: dogsPath, component: DogsGrid, moduleCodes: [dogsCode], permissions: [dogsPermission] },
  { path: bicyclesPath, component: BicyclesGrid, moduleCodes: [bicyclesCode], permissions: [bicyclesPermission] },
  { path: mapPath, component: MetropolisMap, moduleCodes: [mapCode], permissions: [mapPermission] },
  { path: '/hr/plans', component: MyPlans, moduleCodes: [hrCode], permissions: [hrMyPlansPermission] },
  { path: '/hr/my', component: MyOverview, moduleCodes: [hrCode], permissions: [hrMyPermission] },
  { path: '/hr/overviews', component: AllOverviews, moduleCodes: [hrCode], permissions: [hrRequestsPermission] },
  { path: requestsPayPath, component: RequestsPayGrid, moduleCodes: [hrCode], permissions: [hrRequestsPermission] },
  {
    path: requestsHolidayPath,
    component: RequestsHolidayGrid,
    moduleCodes: [hrCode],
    permissions: [hrRequestsPermission]
  },
  {
    path: '/hr/work-times/overview',
    component: SummaryForm,
    moduleCodes: [hrCode],
    permissions: [hrWorkTimesPermission]
  },
  { path: claimsPath, component: ClaimsGrid, moduleCodes: [hrCode], permissions: [hrWorkTimesPermission] },
  { path: periodsPath, component: PeriodsGrid, moduleCodes: [hrCode], permissions: [hrTemplatesPermission] },
  { path: daysPath, component: DaysGrid, moduleCodes: [hrCode], permissions: [hrTemplatesPermission] },
  { path: weeksPath, component: WeeksGrid, moduleCodes: [hrCode], permissions: [hrTemplatesPermission] },
  { path: calendarsPath, component: CalendarsGrid, moduleCodes: [hrCode], permissions: [hrTemplatesPermission] },
  {
    path: '/hr/employee/detail/:id',
    component: EmployeeDetail,
    moduleCodes: [hrCode],
    permissions: [hrTemplatesPermission]
  },
  { path: dayplansPath, component: DayplansGridSingle, moduleCodes: [hrCode], permissions: [hrDayplansPermission] },
  { path: '/hr/dayplans/bulk', component: DayplansForm, moduleCodes: [hrCode], permissions: [hrDayplansPermission] },
  { path: shiftsPath, component: ShiftsGrid, moduleCodes: [hrCode], permissions: [hrShiftsPermission] },
  { path: shiftsCyclesPath, component: ShiftCyclesGrid, moduleCodes: [hrCode], permissions: [hrShiftsPermission] },
  {
    path: '/hr/shifts/cycles/detail/:id',
    component: ShiftCycleDetail,
    moduleCodes: [hrCode],
    permissions: [hrShiftsPermission]
  },
  { path: workPositionsPath, component: WorkPositionsGrid, permissions: [hrWorkPositionsPermission] },
  { path: workDayTypesPath, component: WorkDayTypesGrid, permissions: [workDayTypesPermission] },
  {
    path: inventoryCardsPath,
    component: InventoryCardsGrid,
    moduleCodes: [warehousesCode],
    permissions: [warehouseInventoryCardsPermission]
  },
  {
    path: protocolsPath,
    component: ProtocolsGrid,
    moduleCodes: [warehousesCode],
    permissions: [warehouseProtocolsPermission]
  },
  {
    path: operationalWarehousePath,
    component: OperationalWarehouseGrid,
    moduleCodes: [operationalWarehousesCode],
    permissions: [operationalWarehousePermission]
  },
  {
    path: myItemsPath,
    component: MyItemsGrid,
    moduleCodes: [operationalWarehousesCode],
    permissions: [operationalWarehousePermission]
  },
  {
    path: myRequestsPath,
    component: MyRequestsGrid,
    moduleCodes: [operationalWarehousesCode],
    permissions: [operationalWarehouseOwnListPermission]
  },
  {
    path: requestsPath,
    component: RequestsGrid,
    moduleCodes: [operationalWarehousesCode],
    permissions: [operationalWarehouseRequestListPermission]
  },
  {
    path: '/warehouses/protocols/procurement',
    component: withProps({ protocolType: protocolCreateFormEnum.PROCUREMENT })(ProtocolsForm),
    permissions: [warehouseProtocolsPermission]
  },
  {
    path: '/warehouses/protocols/issue',
    component: withProps({ protocolType: protocolCreateFormEnum.ISSUE })(ProtocolsForm),
    permissions: [warehouseProtocolsPermission]
  },
  {
    path: '/warehouses/protocols/receipt',
    component: withProps({ protocolType: protocolCreateFormEnum.RECEIPT })(ProtocolsForm),
    permissions: [warehouseProtocolsPermission]
  },
  {
    path: '/warehouses/protocols/disposal',
    component: withProps({ protocolType: protocolCreateFormEnum.DISPOSAL })(ProtocolsForm),
    permissions: [warehouseProtocolsPermission]
  },
  {
    path: '/warehouses/protocols/transfer',
    component: withProps({ protocolType: protocolCreateFormEnum.TRANSFER })(ProtocolsForm),
    permissions: [warehouseProtocolsPermission]
  },
  { path: tripsPath, component: TripsGrid, moduleCodes: [tripsCode], permissions: [tripsPermission] },
  {
    path: wantedPersonPath,
    component: WantedPersonsGrid,
    moduleCodes: [wantedPersonCode],
    permissions: [wantedPermission]
  },
  {
    path: wantedVehiclesPath,
    component: WantedVehiclesGrid,
    moduleCodes: [wantedVehiclesCode],
    permissions: [wantedPermission]
  },
  { path: repairsPath, component: RepairsGrid, permissions: [repairsPermission] },
  {
    path: '/repairs/repair',
    component: withProps({ repairType: RepairType.REPAIR })(RepairsCreateForm),
    permissions: [repairsPermission]
  },
  {
    path: '/repairs/maintenance',
    component: withProps({ repairType: RepairType.MAINTENANCE })(RepairsCreateForm),
    permissions: [repairsPermission]
  },
  { path: reportsPath, component: ReportsGrid, permissions: [reportsPermission] },
  { path: '/dictionary', component: Dictionary, exact: false, permissions: [dictionariesPermission] },
  { path: historyPath, component: HistoryGrid, permissions: [historyPermission] },
  { path: '/administration/settings', component: GeneralSettingsForm, permissions: [administrationPermission] },
  { path: errorsPath, component: ErrorsGrid, permissions: [administrationPermission] },
  { path: rolesCreatePath, component: RolesCreateGrid, permissions: [administrationPermission] },
  { path: rolesAssignPath, component: RolesAssignGrid, permissions: [administrationPermission] },
  { path: jobsPath, component: JobsGrid, permissions: [administrationPermission] }
];



// WEBPACK FOOTER //
// ./src/routes.ts